import { render, staticRenderFns } from "./index.vue?vue&type=template&id=402a2030&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=402a2030&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_babel-core@7.0.0-bridge.0_@babel+core@7.28._1da236c8e1011b09e2b962f3be253da7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402a2030",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre_h5-dcms/pre/h5dcms/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('402a2030')) {
      api.createRecord('402a2030', component.options)
    } else {
      api.reload('402a2030', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=402a2030&scoped=true", function () {
      api.rerender('402a2030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Copy/index.vue"
export default component.exports